/**
 * Created by Administrator on 2018/9/18.
 */
import Alert from '../components/alert/index'

import TakeoutDialog from "../components/takeoutDialog/index"
import ServiceUtils from "./ServiceUtils";
export default{


  /**
   * 单个按钮弹框
   * @param title
   * @param msg
   * @param callback
   */
  showAlert(title,msg,callback){
    console.log(msg);
    Alert.open({title:title,content:msg},(res)=>{
      if(res && callback){callback()}
    });
  },
  /**
   * 双按钮弹框
   * @param title
   * @param msg
   * @param yes
     * @param no
     */
  confirm(title,msg,yes,no,yestext,notext){

    Alert.open({title:title,content:msg,okText:yestext||'确认',noText:notext||'取消'},(res)=>{
      if(res && yes){yes();
      }else{if(no){no();}}
    });
  },


  /**
   * 双按钮弹框
   * @param title
   * @param msg
   * @param yes
   * @param no
   */
  confirmAlipay(title,msg,yes,no){
    MessageBox.confirm('', {
      message: msg,
      title:title,
      confirmButtonClass:'confirmBtClass',
      cancelButtonClass:'confirmBtClass',
      confirmButtonText:"支付宝支付"
    }).then(action => {
      if (action == 'confirm') {     //确认的回调
        if(yes){
          yes();
        }
      }
    }).catch(err => {
      if (err == 'cancel') {     //取消的回调
        if(no){
          no();
        }
      }
    });
  },
    /**
     * 外卖设置对话框
     * @param userdata 用户数据
     * {address:"地址","tel":"电话","gdLat":"高德纬度","gdLng":"高德经度"}
     * @param callback
     * @constructor
     */
  OpenUserTakeoutSet:function (storeInfo,callback) {
    TakeoutDialog.open(storeInfo,callback);
  }
}



// WEBPACK FOOTER //
// ./src/service/ServiceDialog.js